import translates from './en.json';
import restNotifications from './notifiers.json';

export default {
  en: { ...translates, ...restNotifications },
};
